import React from 'react';
import styles from './styles';

const EmailRecipients = props => {
  return (
    <ul style={styles.list}>
      {props.data.map((recipient, i) => (
        i <= 5 ?
        <li key={i} style={styles.listItem}>
          <span>{recipient.name}</span><br />
          <span>{recipient.email}</span>
        </li>
        : i === 6 ?
        <li key={i} style={{...styles.listItem, ...styles.lastListItem}}>
          <span>...{props.data.recipients.length - 6} More</span>
        </li>
        : null
      ))}
    </ul>
  )
}

export default EmailRecipients;
